import { render, staticRenderFns } from "./change_build.vue?vue&type=template&id=754a6804&scoped=true&"
import script from "./change_build.vue?vue&type=script&lang=js&"
export * from "./change_build.vue?vue&type=script&lang=js&"
import style0 from "./change_build.vue?vue&type=style&index=0&id=754a6804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754a6804",
  null
  
)

export default component.exports